<template>
  <v-container fluid class="pt-0 px-0">
    <reporting-hub-app-bar></reporting-hub-app-bar>
    <loading-spinner v-if="loading"></loading-spinner>
    <v-container v-else class="pa-0">
      <v-row>
        <v-col cols="12">
          <v-slide-group show-arrows class="px-2">
            <v-slide-item v-for="(filter, i) in filters" :key="i" v-slot="{}">
              <v-btn
                :outlined="filterId != filter.url"
                color="secondary"
                large
                rounded
                :to="
                  filter.id && filterId != filter.url
                    ? `/reporting/${filter.url}`
                    : '/reporting'
                "
                class="mr-3"
                exact
              >
                <v-img
                  :src="
                    filter.imageUrl
                      .replace(
                        '{color}',
                        filterId == filter.url
                          ? $vuetify.theme.themes.light.white
                          : $vuetify.theme.themes.light.secondary
                      )
                      .replace('#', '')
                  "
                  v-if="filter.imageUrl"
                  max-width="20"
                  class="mr-2"
                ></v-img>
                {{ filter.name }}
              </v-btn>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="6"
          md="4"
          v-for="(report, i) in filtered_reports"
          :key="i"
        >
          <v-card class="full-height">
            <v-card-text class="py-4 full-height d-flex flex-column">
              <v-row dense>
                <v-col class="lighttext--text">
                  {{ report.header }}
                </v-col>
                <v-spacer> </v-spacer>
                <v-col cols="auto">
                  <v-btn
                    icon
                    color="error"
                    x-small
                    @click="saveFavorite(report.id, !favorite(report.id))"
                  >
                    <v-icon>
                      {{ favorite(report.id) ? "favorite" : "favorite_border" }}
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12">
                  <v-card-title class="pa-0">
                    {{ t2(report.name) }}
                  </v-card-title>
                </v-col>
                <v-col cols="12" class="lighttext--text pb-4">
                  {{ report.description }}
                </v-col>
              </v-row>
              <v-row dense align="end" class="fill-height">
                <v-col cols="12">
                  <v-btn
                    block
                    :to="`/reporting/${report.typeUrl}/${report.url}`"
                    color="secondary"
                    outlined
                  >
                    View Report
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import reports from "@/helpers/mixins/reports";
import ReportingHubAppBar from "@/components/reporting/ReportingHubAppBar";
import { getReportingCompany, setReportingCompany } from "@/helpers/local";
export default {
  components: { ReportingHubAppBar },
  name: "ReportingHub",
  data: () => ({ loading: false }),
  mixins: [reports],
  computed: {
    favorite() {
      return reportId => {
        return (this.profile.favoriteReportIds || []).includes(reportId);
      };
    },
    reportingCustomerId() {
      return this.$auth.isSuperAdmin() || this.$auth.isCoreCoach()
        ? getReportingCompany()
        : null;
    },
    filterId() {
      return this.$route.params.filterId;
    },
    settings() {
      return this.$store.getters[
        this.reportingCustomerId
          ? "customer/customer_settings"
          : "profile/settings"
      ];
    },
    filters() {
      let self = this;
      let data = this._.orderBy(
        this.report_types.filter(
          x =>
            (!x.featureIds ||
              x.featureIds.filter(y => self.settings.featureIds.includes(y))
                .length > 0) &&
            (!x.locale || x.locale == this.$vuetify.lang.current)
        ),
        ["sort"],
        ["asc"]
      );
      data.unshift({ name: "All" });
      return data;
    },
    filtered_reports() {
      let self = this;
      let data = this.reports;

      if (this.filterId) {
        data = data.filter(x => x.typeUrls.indexOf(this.filterId) >= 0);
      }

      if (!this.$auth.isSuperAdmin()) {
        data = data.filter(x => x.typeUrl != "usage");
      }

      return this._.sortBy(data, [
        function(o) {
          return !self.favorite(o.id);
        },
        function(o) {
          return o.sort;
        }
      ]);
    },
    ...mapGetters({
      report_types: "lookup/report_types",
      reports: "reporting/reports",
      profile: "profile/profile"
    })
  },
  created() {
    if (this.$auth.isSuperAdmin() || this.$auth.isCoreCoach()) {
      let customerId = this.$route.query.customerId;
      if (customerId) {
        this.loading = true;
        this.$store
          .dispatch("customer/getCustomerSettings", customerId)
          .then(settings => {
            setReportingCompany(customerId, settings.companyName);
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occured while loading customer settings."
            );
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
    this.$store.dispatch("reporting/getReports");
  },
  methods: {
    saveFavorite(reportId, isFavorite) {
      this.$store
        .dispatch("profile/saveReportFavorite", { reportId, isFavorite })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while saving a report favorite."
          );
        });
    }
  }
};
</script>
